import { handleActions } from '../../helpers/immer';
import * as action from '../../actions/Sidebar';

const initialValue = {
  headerPanel: false,
  rightPanel: false,
  sideNav: false,
  data: {
    cash: null,
    ranking: null,
    user_team: null,
    user_id: null,
    second_user: null,
  },
  loading: false,
};

export const sidebar = handleActions(
  {
    [action.openRightPanel]: (draft, { payload }) => {
      draft.rightPanel = payload.view;
    },
    [action.showHeaderPanel]: (draft, { payload }) => {
      draft.headerPanel = payload.view;
    },
    [action.openSideNavigation]: (draft, { payload }) => {
      draft.sideNav = payload.view;
    },
    // ---------------GET DATA FOR SIDEBAR-----------------
    [action.getDataForSidebar]: (draft, { payload }) => {
      draft.loading = false;
      draft.data.cash = payload.current_cash;
      draft.data.ranking = payload.ranking;
      draft.data.user_team = payload.user_team;
      draft.data.second_user = payload.second_user;
    },
    [action.dataForSidebarLoaded]: (draft, { payload }) => {
      draft.loading = true;
    },
  },
  initialValue
);
